import * as React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Player } from 'video-react';
import 'node_modules/video-react/dist/video-react.css';

import { Input, InputField, Upload, UploadField } from '@components/form';
import { Loader } from '@components/loader';

import * as T from '@modules/events/_eventsTypes';
import { ImageViewer } from '@components/imageViewer';

const enhance = compose<T.EventsFormProps, T.Outter & T.EventsFormProps & { setDisableSps: any }>(
  connect(
    state => ({
      photos: formValueSelector('module-events-photos')(state, 'photos') || [],
      fileRef: formValueSelector('module-events-eventPhotos-photos')(state, 'fileRef'),
      note: formValueSelector('module-events-eventPhotos-photos')(state, 'note')
    }),
    dispatch => {
      return {
        changeFieldValue: value => {
          dispatch(change('module-events-photos', 'photos', value));
        }
      };
    }
  ),
  withState('inProgress', 'setInProgress', false),
  withHandlers({
    onSubmit: ({ changeFieldValue, photos, closeItem }) => formData => {
      const fileRef = get(formData, 'fileRef');
      const note = get(formData, 'note');

      const editedPhotoIndex = fileRef ? photos.findIndex(o => get(o, 'file.id') === fileRef.id) : -1;

      if (editedPhotoIndex !== -1) {
        const newPhotos = [...photos];
        newPhotos[editedPhotoIndex] = { file: fileRef, note };
        changeFieldValue(newPhotos);
      } else {
        changeFieldValue([...photos, { file: fileRef, note }]);
      }

      closeItem();
    }
  }),
  lifecycle<any, any>({
    componentWillReceiveProps({ fileRef }: any) {
      if (this.props.fileRef !== fileRef) {
        this.props.setInProgress(false);
      }
    },
    componentWillUnmount() {
      this.props.setInProgress(false);
    }
  }),
  withProps(({ initialValues }) => ({
    initialValues: {
      ...initialValues,
      fileRef: get(initialValues, 'file'),
      note: get(initialValues, 'note')
    }
  })),
  reduxForm({
    form: 'module-events-eventPhotos-photos'
  })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, fileRef, inProgress, setInProgress }) => (
  <div style={{ maxHeight: '80vh', overflow: 'auto' }}>
    {inProgress && <Loader />}
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Soubor</h4>
              </Col>
              <Col md={8}>
                <UploadField
                  component={Upload}
                  name="fileRef"
                  accept="image/*,video/*"
                  onStart={() => setInProgress(true)}
                  onError={() => setInProgress(false)}
                  onAbort={() => setInProgress(false)}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Náhled</h4>
              </Col>
              <Col md={8} style={{ height: 300 }}>
                {fileRef &&
                  fileRef.contentType.includes('video') && (
                    <Player
                      playsInline={true}
                      src={`/metropolis/api/ed/event/files/video/${fileRef.id}/stream`}
                      fluid={false}
                      height={300}
                    />
                  )}
                {fileRef &&
                  fileRef.contentType.includes('image') && (
                    <ImageViewer src={`/metropolis/api/files/${fileRef.id}`} alt="Náhled" />
                  )}
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Poznámka</h4>
              </Col>
              <Col md={8}>
                <InputField component={Input} label="Poznámka" name="note" />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button
        type="submit"
        label="Uložit a zavřít"
        primary={true}
        disabled={!fileRef}
        style={{ margin: '16px 0 16px 16px' }}
      />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EventsFormPhotosMultiForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormPhotosMultiForm.tsx